module.exports = __webpack_public_path__ + "static/img/532_phase_function_Paper_PointsHejduk_Prediction.93bbcd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/532_phase_function_Paper_PointsHejduk_Prediction.png
// module id = IXJe
// module chunks = 0